<template>
  <div class="download">
    <banner :img="require('@/assets/img/appDown.jpg')" title="下载小程序" :height="200" />
    <div class="download-content">
      <div class="qr-container">
        <div class="qr-card">
          <h2>扫描二维码下载</h2>
          <p>使用微信扫描下方二维码，即可快速体验我们的小程序</p>
          <div class="qr-code">
            <img src="../assets/img/ercode.png" alt="小程序二维码" />
          </div>
          <p class="instructions">微信扫码 · 立即体验</p>
        </div>

        <div class="features">
          <h3>小程序特色功能</h3>
          <ul>
            <li>实时监控电池状态</li>
            <li>远程参数配置</li>
            <li>历史数据查询</li>
            <li>故障预警提醒</li>
            <li>设备资产管理</li>
          </ul>
        </div>

        <div class="support-info">
          <h3>技术支持</h3>
          <p>如有任何疑问，请联系我们的客服：</p>
          <p class="contact-info">邮箱：ehuatech@163.com</p>
          <p class="contact-info">电话：0755-84872724</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  }
};
</script>

<style lang="scss" scoped>
.download {
  width: 100%;
  min-height: 100vh;
  background-color: #f8f9fa;

  .download-content {
    max-width: 1240px;
    margin: 0 auto;
    padding: 40px 20px;

    .qr-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 40px;

      .qr-card {
        background: white;
        border-radius: 16px;
        padding: 40px;
        text-align: center;
        box-shadow: 0 8px 30px rgba(0,0,0,0.12);
        max-width: 500px;
        width: 100%;
        margin: 0 auto;

        h2 {
          color: #1a75bb;
          font-size: 28px;
          margin-bottom: 15px;
          font-weight: 600;
        }

        p {
          color: #666;
          font-size: 16px;
          margin-bottom: 30px;
          line-height: 1.6;
        }

        .qr-code {
          width: 220px;
          height: 220px;
          margin: 0 auto 25px;
          padding: 15px;
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 15px rgba(0,0,0,0.1);
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .instructions {
          font-size: 18px;
          color: #1a75bb;
          font-weight: 500;
          margin: 0;
        }
      }

      .features {
        background: white;
        border-radius: 16px;
        padding: 40px;
        text-align: center;
        box-shadow: 0 8px 30px rgba(0,0,0,0.12);
        max-width: 500px;
        width: 100%;
        margin: 0 auto;

        h3 {
          color: #1a75bb;
          font-size: 24px;
          margin-bottom: 25px;
          font-weight: 600;
        }

        ul {
          list-style: none;
          padding: 0;
          text-align: left;

          li {
            padding: 12px 0;
            padding-left: 30px;
            position: relative;
            font-size: 16px;
            color: #444;
            border-bottom: 1px solid #f0f0f0;

            &:last-child {
              border-bottom: none;
            }

            &::before {
              content: "✓";
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              color: #28a745;
              font-weight: bold;
            }
          }
        }
      }

      .support-info {
        background: white;
        border-radius: 16px;
        padding: 40px;
        text-align: center;
        box-shadow: 0 8px 30px rgba(0,0,0,0.12);
        max-width: 500px;
        width: 100%;
        margin: 0 auto;

        h3 {
          color: #1a75bb;
          font-size: 24px;
          margin-bottom: 20px;
          font-weight: 600;
        }

        p {
          color: #666;
          font-size: 16px;
          margin: 10px 0;
          line-height: 1.6;
        }

        .contact-info {
          color: #1a75bb;
          font-weight: 500;
          font-size: 17px;
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .download-content {
    padding: 20px 15px !important;
  }

  .qr-card,
  .features,
  .support-info {
    padding: 30px 20px !important;
    margin: 0 auto !important;
  }

  .qr-code {
    width: 180px !important;
    height: 180px !important;
    margin: 0 auto 20px !important;
  }

  h2 {
    font-size: 24px !important;
  }

  h3 {
    font-size: 20px !important;
  }
}

@media (max-width: 480px) {
  .download-content {
    padding: 15px 10px !important;
  }

  .qr-card,
  .features,
  .support-info {
    padding: 25px 15px !important;
  }

  .qr-code {
    width: 150px !important;
    height: 150px !important;
  }

  h2 {
    font-size: 22px !important;
  }

  .instructions {
    font-size: 16px !important;
  }

  .contact-info {
    font-size: 15px !important;
  }
}
</style>